import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetVotacoes() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getVotacoes = useCallback(
        (usuario: string) =>
            invocarApi({
                url: `/api/v1/votacao?usuario=${usuario}`,
                method: 'GET',
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.apiClickupLicUrl,
                timeout: 30000
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getVotacoes,
    };
}
